import { AppliedAt } from '@wix/ambassador-pricing-plans-v3-plan/types';

/**
 * @returns true if pricing variant has setup fee.
 */
export const hasSetupFeeVariant = variant => {
  var _variant$fees;
  const firstFee = variant == null || (_variant$fees = variant.fees) == null ? void 0 : _variant$fees[0];
  return Boolean(firstFee && firstFee.appliedAt === AppliedAt.FIRST_PAYMENT);
};

/**
 * @returns setup fee name or undefined if setup fee doesn't exist
 */
export const getVariantSetupFeeName = variant => {
  var _variant$fees2;
  const firstFee = variant == null || (_variant$fees2 = variant.fees) == null ? void 0 : _variant$fees2[0];
  return hasSetupFeeVariant(variant) ? firstFee == null ? void 0 : firstFee.name : undefined;
};

/**
 * @returns setup fee amount or undefined if setup fee doesn't exist
 */
export const getVariantSetupFeeAmount = variant => {
  var _variant$fees3, _firstFee$fixedAmount;
  const firstFee = variant == null || (_variant$fees3 = variant.fees) == null ? void 0 : _variant$fees3[0];
  return hasSetupFeeVariant(variant) ? firstFee == null || (_firstFee$fixedAmount = firstFee.fixedAmountOptions) == null ? void 0 : _firstFee$fixedAmount.amount : undefined;
};
//# sourceMappingURL=setup-fee.js.map